import React, { useCallback, useEffect, useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const DEFAULT_HEIGHT = 16;
type ScrollTopProps = {
  footerHeight?: string;
};
export default function ScrollTop(props: ScrollTopProps) {
  // 画面最下部までスクロールしたかどうか
  const [isBottom, setIsBottom] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      // スタイルのheightを考慮して、ボタンの位置を調整
      const footerHeightNum =
        props.footerHeight != null ? parseInt(props.footerHeight, 10) : DEFAULT_HEIGHT;
      setIsBottom(scrollTop + windowHeight >= documentHeight - footerHeightNum);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [setIsBottom]);

  // フッタの高さが取得できた場合は、フッタの高さを考慮してボタンの位置を調整
  const footerHeight = props.footerHeight; // Adjust this value according to your footer height
  const bottom = footerHeight
    ? `calc(${footerHeight} + ${DEFAULT_HEIGHT}px)`
    : `${DEFAULT_HEIGHT}px`;

  // ボタン押下時
  const onClickTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const label = 'TOPに戻る';

  return (
    <div
      className={`fixed transition-[bottom] left-4`}
      style={{ bottom: isBottom ? bottom : DEFAULT_HEIGHT }}
    >
      <button
        style={{ background: 'var(--c-button-background)' }}
        className={
          'rounded-[300px] ' +
          'h-8 ' +
          'w-8 ' +
          'text-[--c-button-text] ' +
          'focus:outline-none ' +
          'focus:ring-2 ' +
          'focus:ring-[--c-primary-color] ' +
          'disabled:bg-gray-400 ' +
          'disabled:cursor-not-allowed '
        }
        onClick={onClickTop}
        onMouseEnter={(e) =>
          (e.currentTarget.style.background = 'var(--c-button-background-hover)')
        }
        onMouseLeave={(e) => (e.currentTarget.style.background = 'var(--c-button-background)')}
        aria-label={label}
      >
        <ExpandLessIcon />
      </button>
    </div>
  );
}
